"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadYouTubeIframe = void 0;
const window_or_global_1 = __importDefault(require("window-or-global"));
/**
 * Function for loading youtube frames after dom content is loaded
 */
const loadYouTubeIframe = () => {
    window_or_global_1.default.document.addEventListener('DOMContentLoaded', () => {
        const tag = window_or_global_1.default.document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = window_or_global_1.default.document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }, false);
};
exports.loadYouTubeIframe = loadYouTubeIframe;
//# sourceMappingURL=yt.js.map